import React from 'react';
import './styles.scss';


class HiresCardOne extends React.Component {
  render() {

    const { icon, text } = this.props

    return (
      <div className="hires__card__container">
        <div className="plus__button"></div>
        <div className="hires__card__content">
          <img class="telephone" src={icon} alt="Telephone" />
          <h5 className="hires__card__text">{text}</h5>
          <button className="hires__card__button">lo quiero</button>
        </div>
    </div>
    )
  }
}


export default HiresCardOne;
